import styled from 'styled-components'

const bemComponentName = 'viewLayout'

export const classes = {
  wrappingBox: `${bemComponentName}__wrappingBox`,
  titleWrapper: `${bemComponentName}__titleWrapper`,
  subtitleWrapper: `${bemComponentName}__subtitleWrapper`,
  rowsContentWrapper: `${bemComponentName}__rowsContentWrapper`,
  introductionText: `${bemComponentName}__introductionText`,
  actionImage: `${bemComponentName}__actionImage`,
  ctaButton: `${bemComponentName}__ctaButton`,
  ctaIcon: `${bemComponentName}__ctaIcon`,
  alertLayer: `${bemComponentName}__alert`,
  orDivider: `${bemComponentName}__orDivider`,
  orDividerRule: `${bemComponentName}__orDividerRule`,
  orDividerLabel: `${bemComponentName}__orDividerLabel`,
  firmMemberButton: `${bemComponentName}__firmMemberButton`,
  firmMemberButtonWrap: `${bemComponentName}__firmMemberButtonWrap`,
  firmMemberAuthBlock: `${bemComponentName}__firmMemberAuthBlock`,
}

const wrappingBoxPadding = '4rem'

const ViewLayout = styled.div`
  .${classes.wrappingBox} {
    padding: 1.5rem;
    position: relative;
    height: auto;
    min-height: calc(100vh - 200px);

    @media (min-width: 600px) {
      min-height: calc(100vh - 350px);
      padding: 32px 4rem;
    }
  }

  .${classes.rowsContentWrapper} {
    display: flex;
    flex-direction: column;
    row-gap: 2rem;
    align-items: center;
  }

  .${classes.ctaButton} {
    width: 100%;
    padding: 20px 0;
    margin-top: 1rem;
    margin-bottom: 1rem;

    > .mds-button-children {
      vertical-align: middle;

      svg {
        width: calc(1rem + 0.25rem);
        height: auto;
        margin: 0 0.5rem;
        display: inline-block;
      }
    }
  }

  .${classes.ctaIcon} {
    margin-right: 0.5rem;
  }

  .${classes.titleWrapper} {
    margin: 1.25rem 0 4px 0;
    margin-top: 0.25rem;
    text-align: center;
    font-weight: 500;
    font-size: 24px;
    line-height: 28px;
    color: #000;
  }

  .${classes.subtitleWrapper} {
    display: block;
    width: 100%;
    margin: 0 auto;
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #999;
  }

  .${classes.alertLayer} {
    margin: ${wrappingBoxPadding} -${wrappingBoxPadding};
    padding-left: ${wrappingBoxPadding};
    padding-right: ${wrappingBoxPadding};
  }

  @media screen and (min-width: 394px) {
    .${classes.titleWrapper} {
      margin-top: 32px;
    }
  }
`

export default ViewLayout
